export const colorPalette = [
  '#52489C',
  '#4062BB',
  '#59C3C3',
  '#535e79',
  '#F45B69',
];
